import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { ContactFormRequestBody, ContactFormResponse } from "../../core/api/request/contact/types";

const actionCreator = actionCreatorFactory("@@Contact");

export const contactActions = {
    contactForm: actionCreator.async<CommonAsyncType<ContactFormResponse> & ContactFormRequestBody, ContactFormResponse>("CONTACT_FORM"),
    resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE")
}